






























































































import Vue from 'vue'

/**  Model **/
import { IRutaModel } from '@/store/types'

/**  Views **/

/**  Service **/
import RutaService from '@/services/RutaService'

/**  Views **/

export default Vue.extend({
  components: {},

  data() {
    return {
      help: {
        title: 'Registrar Ruta',
        subtitle: '',
        message: 'En esta página podrás registrar tus rutas.'
      },

      formReserva: { dialog: false },

      num: '+573134492451',

      ruta: {} as IRutaModel,

      rutas: [] as IRutaModel[]
    }
  },

  computed: {
    formRecord() {
      return this.$refs.formRecord as Vue & { validate: () => boolean; reset: () => void }
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    calcularCupos(item: IRutaModel) {
      if (!item.Reservas) item.Reservas = []

      const Pendiente = item.Reservas.filter((f) => f.Estado === 'Pendiente').length || 0
      const Confirmada = item.Reservas.filter((f) => f.Estado === 'Confirmada').length || 0

      item.CuposPendientes = Pendiente
      item.CuposConfirmados = Confirmada
      item.CuposDisponibles = item.CuposOfertar - Confirmada

      return item
    },

    getLocation() {
      return location.origin + '/#/'
    },

    formatPrice(value: number) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return (
        '$ ' +
        val
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          .replace(',00', '')
      )
    },

    async getRutas() {
      this.rutas = (await RutaService.findAll()) as any
    },

    async load() {
      if (this.$route.params.id) {
        this.$store.dispatch('app/showLoading')
        const response = (await RutaService.findById({ Id: this.$route.params.id } as any)) as any
        this.ruta = response
        this.help.title = response.Nombre
        this.help.message = ''
        this.getRutas()
        this.$store.dispatch('app/hideLoading')
        setTimeout(() => {
          window.print()
        }, 2000)
      } else {
        this.$router.push('/experiencias')
      }
    },

    cancel() {
      this.$router.push('/experiencias')
    }
  }
})
